import { useId } from "react";
import { Field } from "react-final-form";
import { useText } from "../../../hooks";
import type { LangKey } from "../../../types/lang";
import type { SimpleAnswer, SimpleQuestion } from "../../../types/question";
import { isRequired } from "../../../utils/validation";
import { FormHelperText, Legend } from "../../form-fields";
import { TextInput } from "../../form-fields/components/text-input";
import { Stack } from "../../stack";
import { formatFieldName } from "../utils";

type Props = {
	question: SimpleQuestion;
};

const parseAnswer = (value: string): [SimpleAnswer] => [{ answerValue: value }];
const formatAnswer = (answer: [SimpleAnswer]) => (answer ? answer[0].answerValue : "");
const validate = (value: [SimpleAnswer] = [{ answerValue: "" }]) =>
	isRequired(value[0].answerValue); // todo: custom validation fn?
const defaultValue: [SimpleAnswer] = [{ answerValue: "" }];

const TextQuestion = ({ question }: Props) => {
	const [t] = useText();
	const describedById = useId();
	const labelledById = useId();
	return (
		<Field<[SimpleAnswer], HTMLElement, string>
			name={formatFieldName(question.questionId)}
			parse={parseAnswer}
			format={formatAnswer}
			defaultValue={defaultValue}
			validate={validate}
		>
			{({ meta, input }) => (
				<Stack gap={1}>
					<Legend id={labelledById}>{question.question}</Legend>
					<TextInput
						{...input}
						fullWidth
						type="text"
						label={question.helpText || undefined}
						aria-labelledby={!question.helpText ? labelledById : undefined}
						aria-describedby={describedById}
					/>
					{meta.submitFailed && (
						<FormHelperText error={!!meta.error && meta.submitFailed} id={describedById}>
							{t(meta.error as LangKey)}
						</FormHelperText>
					)}
				</Stack>
			)}
		</Field>
	);
};

export default TextQuestion;
